import React, { useMemo, useState } from 'react'
import { useTranslation } from 'next-i18next/pages'
import { FilterListProps } from '../../FilterTypes'
import { formatPriceLabel } from './formatPriceLabel'
import { Maybe, AggregationOption } from '@pylot-data/fwrdschema'
import { getSelectedItemsFromFilterData } from './getSelectedItems'
import { MemoMultiselectInput, RadioInput } from './FilterItem'
import { MoreLessLink } from './MoreLessLink'

import s from './FilterList.module.scss'

import cn from 'classnames'

export const FilterList = (props: FilterListProps): JSX.Element => {
    const {
        items,
        availableValues,
        requestVar,
        applyFilter,
        isLoading,
        showCount,
        currencyCode,
        appliedFilterData,
        showMoreSize = 7,
        isHorizontal,
        initialFilterAttribute
    } = props

    const { t } = useTranslation(['plp'])

    const [maxItemsPerList, setMaxItemsPerList] = useState(
        !isHorizontal && showMoreSize ? showMoreSize : items.length
    )

    const selectedItems = useMemo(
        () => getSelectedItemsFromFilterData(appliedFilterData, requestVar),
        [requestVar, appliedFilterData]
    )

    const statusArray = items.map((item: Maybe<AggregationOption>) =>
        selectedItems.includes(item!.value)
    )

    const getItemLabel = (label?: Maybe<string>): string => {
        if (typeof label !== 'string') {
            return ''
        }
        return requestVar === 'price'
            ? formatPriceLabel(t, label, currencyCode)
            : label
    }

    const getItemValue = (
        requestVar: string,
        value: string,
        label?: Maybe<string>
    ): string => {
        if (requestVar == 'price' && value == '') {
            return label?.replace('-', '_') || ''
        }
        return value
    }

    const itemElements = items.map((item, index) => {
        if (!item) {
            return
        }
        const { label, value, count, swatch_data } = item as AggregationOption
        const filterTypeInput = {
            requestVar,
            value_string: getItemValue(requestVar, value, label),
            label: getItemLabel(label),
            swatch_data
        }

        if (index < maxItemsPerList) {
            return (
                <li
                    key={`item-${index}-${value}`}
                    className={cn(s['filter-item'])}
                >
                    <MemoMultiselectInput
                        filterTypeInput={filterTypeInput}
                        applyFilter={applyFilter}
                        count={count || 0}
                        showCount={showCount}
                        isChecked={statusArray[index]}
                        key={`${index}-${value}`}
                        isLoading={isLoading}
                        availableValues={availableValues}
                        index={index}
                        statusArray={statusArray}
                        isHorizontal={isHorizontal}
                        initialFilterAttribute={initialFilterAttribute}
                    />
                </li>
            )
        }

        return null
    })

    return (
        <div className={cn(s['item-sub-cat'])}>
            <ul className={requestVar}>
                {itemElements}
                <MoreLessLink
                    isHorizontal={isHorizontal}
                    showMoreSize={showMoreSize}
                    maxItemsPerList={maxItemsPerList}
                    setMaxItemsPerList={setMaxItemsPerList}
                    items={items}
                />
            </ul>
        </div>
    )
}
